var Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV'),
    GraphicNoteModel = require('../../../../models/page/noteTypes/drawable/svg/graphic');

/*
* Backbone Model housing current the color, strokeWidth, and shapeType used when user is drawing graphic notes.
* A new one is created each time a graphic note enters 'edit' mode from the graphic note toolbar.
* Referenced from Canvas Module when applying properties to shapes (color and strokeWidth).
* Encapsulates all interaction with localStorage for clarity.
* Default values define the properties used on newly drawn graphic note shapes.
* GraphicNoteModel referenced here for clarity to show where the default values are defined.
* ( Alternative would be to pass in from the activeNote instance from the caller -- this could prove
*   more beneficial if different defaults are ever employed at the subType level or if any other note types
*   ever require a toolbar selector view. )
* */


module.exports = Backbone.Model.extend({

    defaults: function() {

        var localStorage = fvChannel.request('localStorage'),
            lastColor = localStorage.getLastGraphicNoteShapeColor(),
            lastStrokeWidth = localStorage.getLastGraphicNoteShapeLineWidth(),
            lastShapeType = localStorage.getLastGraphicNoteShape();

        return {

            color: lastColor
                ? lastColor
                : GraphicNoteModel.prototype.getDefaultShapeColor(),

            'stroke-width': lastStrokeWidth
                ? lastStrokeWidth
                :  GraphicNoteModel.prototype.getDefaultStrokeWidth(),

            shapeType: lastShapeType
                ? lastShapeType
                : GraphicNoteModel.prototype.getDefaultShapeSubType()

        };

    },

    setColor: function( color ) {

        this.set('color', color);
        fvChannel.request('localStorage').setLastGraphicNoteShapeColor( color );

    },

    setStrokeWidth: function( width ) {

        this.set('stroke-width', width);
        fvChannel.request('localStorage').setLastGraphicNoteShapeLineWidth( width );

    },

    setShapeType: function( shapeType ) {

        this.set('shapeType', shapeType );
        fvChannel.request('localStorage').setLastGraphicNoteShape( shapeType );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/graphicNoteTB/graphicNoteToolbarState.js
 ** module id = 508
 ** module chunks = 0
 **/